import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { CalendarDays, Sparkles } from "lucide-react";
import FadeInOnScroll from "./FadeInOnScroll"; // 名字随便，但首字母要大写
import SlideInOnScroll from "./SlideInOnScroll";

export default function NewsEvents() {
  const news = [
    {
      title: "Digital:NEX - Asia's Trusted Platform convening Business, Innovation, and Purpose",
      date: "November 2025",
      description:
        "AI NOVA is proud to be the official main sponsor of Digital:NEX Asia 2025, a major event focused on innovation, technology, and collaboration to shape the future of Asia's digital economy.",
      image: "/event.jpg",
      path: "https://www.gevme.com/site/dnexa2025",
    },
    // {
    //   title:
    //     "Partnership with NVIDIA Strengthens AI Infrastructure Capabilities",
    //   date: "August 2025",
    //   description:
    //     "AI NOVA expands its collaboration with NVIDIA to integrate advanced GPU architectures into its cloud computing ecosystem.",
    //   image: "/news/nvidia-partnership.jpg",
    // },
    // {
    //   title: "AI NOVA Hosts 'Intelligent Future' Tech Forum 2025",
    //   date: "May 2025",
    //   description:
    //     "Over 500 industry leaders joined the AI NOVA Forum to discuss the latest trends in AI deployment, edge computing, and sustainability in data centers.",
    //   image: "/news/tech-forum.jpg",
    // },
  ];

  return (
    <>
      <section className="relative overflow-hidden bg-gradient-to-br from-purple-50 via-white to-purple-100 text-[#1e0b44] py-24 px-6">
        {/* 背景装饰图形 */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute w-[28rem] h-[28rem] bg-purple-300/20 rounded-full blur-3xl top-0 -left-20 animate-pulse"></div>
          <div className="absolute w-[32rem] h-[32rem] bg-indigo-300/25 rounded-full blur-3xl bottom-0 right-0 animate-pulse"></div>
        </div>

        {/* Header */}
        <div className="relative max-w-6xl mx-auto text-center mb-20">
          <FadeInOnScroll>
            <h2 className="text-5xl md:text-6xl font-extrabold bg-gradient-to-r from-[#6a2dd9] to-[#9a8dfc] bg-clip-text text-transparent">
              NEWS & EVENTS
            </h2>
            <p className="text-[#5e4ca8] font-medium text-lg mt-4 tracking-wide">
              LATEST UPDATES FROM AI NOVA
            </p>
            <div className="mx-auto mt-6 w-28 h-1 bg-gradient-to-r from-[#a076f9] to-[#7b5cff] rounded-full"></div>
          </FadeInOnScroll>
        </div>

        {/* News Section */}
        <div className="relative max-w-6xl mx-auto flex flex-col gap-20 cursor-pointer">
          {news.map((item, index) => {
            const from = index % 2 === 0 ? "left" : "right";

            return (
              <SlideInOnScroll
                key={index}
                from={from}
                delay={index * 0.1}
              >
                {/* 把整块卡片包在 <a> 里 */}
                <a
                  href={item.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block group"  // 让 hover 还能用 group
                >
                  <div
                    className={`flex flex-col md:flex-row items-center gap-10 bg-white/60 backdrop-blur-xl border border-white/40 p-8 rounded-md shadow-[0_8px_30px_rgba(138,79,255,0.12)] hover:shadow-[0_10px_40px_rgba(138,79,255,0.25)] transition-all duration-300 ${index % 2 === 1 ? "md:flex-row-reverse" : ""
                      }`}
                  >
                    {/* 图片 */}
                    <div className="w-full md:w-1/2 overflow-hidden rounded-md">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-64 md:h-72 object-cover rounded-md transform group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>

                    {/* 内容 */}
                    <div className="w-full md:w-1/2 space-y-4">
                      <div className="flex items-center gap-2 text-[#6a2dd9] font-semibold text-sm uppercase tracking-wider">
                        <CalendarDays size={18} />
                        <span>{item.date}</span>
                      </div>
                      <h3 className="text-2xl font-bold text-[#1e0b44] group-hover:text-[#6a2dd9] transition-colors">
                        {item.title}
                      </h3>
                      <p className="text-[#2a0f4c]/90 leading-relaxed">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </a>
              </SlideInOnScroll>
            );
          })}

        </div>

        <SlideInOnScroll from="right">
          {/* Stay Connected */}
          <div className="relative max-w-4xl mx-auto mt-24 text-center bg-gradient-to-br from-[#a076f9]/20 via-[#ffffff]/40 to-[#7b5cff]/20 p-10 rounded-3xl border border-white/50 shadow-[0_8px_30px_rgba(138,79,255,0.1)] backdrop-blur-md">
            <div className="flex justify-center mb-4">
              <Sparkles className="text-[#6a2dd9]" size={30} />
            </div>
            <h3 className="text-3xl font-extrabold text-[#6a2dd9] mb-3">
              Stay Connected
            </h3>
            <p className="text-[#2a0f4c]/90 leading-relaxed text-lg max-w-2xl mx-auto">
              Follow{" "}
              <span className="font-semibold text-[#6a2dd9]">AI NOVA</span> for
              the latest news, events, launches <br />
              and upcoming global events shaping the future of AI Computing
            </p>
          </div>
        </SlideInOnScroll>
      </section>
    </>
  );
}
